module.exports = __webpack_public_path__ + "static/media/medications-off.3a25a42b.svg";